import { useMemo as i } from "react";
import { useParams as r } from "react-router-dom";
const e = (e2) => {
  const { commercialMeteringPointId: o } = r();
  return i(() => void 0 !== o ? e2.commercialMeteringPointPermission : e2.meteringPointPermission, [o, e2.commercialMeteringPointPermission, e2.meteringPointPermission]);
};
export {
  e as useGetMeteringPointPermissionName
};
//# sourceMappingURL=useGetMeteringPointPermissionName.js.map
